import { SearchTerm } from "./SearchTerm";

const ExpiryReasonSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "erName",
        translationKey: "name"
    }
];

export default ExpiryReasonSearch;
